"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeDiff = exports.getTimeDiffInDays = void 0;
const constants_1 = require("@daytrip/constants");
function getTimeDiffInDays(date1, date2) {
    return getTimeDiff(date1, date2) / constants_1.DAY_IN_MILLISECONDS;
}
exports.getTimeDiffInDays = getTimeDiffInDays;
function getTimeDiff(date1, date2) {
    const secondDateMs = date2 ? new Date(date2).getTime() : Date.now();
    return new Date(date1).getTime() - secondDateMs;
}
exports.getTimeDiff = getTimeDiff;
//# sourceMappingURL=getTimeDiff.js.map